module.exports = __webpack_public_path__ + "img/bg.41a107be.png";